<template>
  <div>
    <HeadlineContainer headline="Invoices" :breadcrumbs="[{text: 'Invoices'}]">
      <div class="btn-group">
        <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-cogs"></i> Functions <span class="caret"></span>
        </button>

        <ul class="dropdown-menu">
          <li>
            <a href="#" @click.prevent="downloadInvoices">
              <i class="fa fa-cloud-download-alt"></i> Download Invoices
            </a>
          </li>

          <li>
            <a href="#download-settlement-modal" data-toggle="modal">
              <i class="fa fa-cloud-download-alt"></i> Download Settlement
            </a>
          </li>
        </ul>
      </div>
    </HeadlineContainer>

    <div class="container">
      <InvoiceList/>
    </div>

    <DownloadSettlementModal/>
  </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import store from '@/store'
import DownloadSettlementModal from '@/components/Modals/Administration/DownloadSettlementModal'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import InvoiceList from "../../../components/Administration/Invoices/Panels/List.vue";

export default {
  components: {InvoiceList, DownloadSettlementModal, HeadlineContainer,},

  data() {
    return {
      shared: store
    }
  },

  methods: {
    downloadInvoices() {
      axios.post('/api/v1/reports/invoices', this.filters, {
        headers: {
          "Authorization": "Bearer " + this.shared.token
        },
        responseType: "blob"
      })
          .then(response => {
            download(response.data, response.headers["content-disposition"].slice(22, -1))
          })
    }
  }
}
</script>
